/* Mitsi & Co v5 motion (2026-10-26). Every effect is progressive: html.v5-motion is only set
   when the visitor allows motion, and content is visible without this file. */
(function () {
  var root = document.documentElement;
  var motion = root.classList.contains('v5-motion');
  window.v5Ready = true;

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* current page in nav */
  $all('nav[aria-label="Main navigation"] a').forEach(function (a) {
    var href = a.getAttribute('href');
    if (href && href !== '/' && location.pathname.indexOf(href) === 0) a.setAttribute('aria-current', 'page');
  });

  /* header: hairline once scrolled, hides on the way down, returns on the way up */
  var nav = document.querySelector('nav[aria-label="Main navigation"]');
  var menu = document.getElementById('mobile-menu');
  if (nav) {
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        nav.classList.toggle('v5-nav-scrolled', y > 8);
        var menuOpen = menu && menu.open;
        var drawerOpen = (document.getElementById('np-drawer') || {classList:{contains:function(){return false;}}}).classList.contains('open');
        if (motion && !menuOpen && !drawerOpen && y > 480 && y > lastY + 4) nav.classList.add('v5-nav-hidden');
        else if (y < lastY - 4 || y <= 480) nav.classList.remove('v5-nav-hidden');
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* section reveals: once, staggered inside their own section */
  var reveals = $all('[data-v5-reveal]');
  if (motion && 'IntersectionObserver' in window) {
    var groups = new Map();
    reveals.forEach(function (el) {
      var sec = el.closest('section') || document.body;
      var n = groups.get(sec) || 0;
      el.style.setProperty('--i', Math.min(n, 6));
      groups.set(sec, n + 1);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* hero: unveil + headline rise, then the color loop */
  var hero = document.querySelector('[data-v5-hero]');
  if (hero) {
    $all('[data-v5-rise]', hero).forEach(function (el, i) { el.style.setProperty('--i', i); });
    var start = function () { requestAnimationFrame(function () { hero.classList.add('is-in'); }); };
    var img = hero.querySelector('.v5-hero-img');
    if (!motion || !img || img.complete) start();
    else { img.addEventListener('load', start, { once: true }); setTimeout(start, 1200); }

    var spot = hero.querySelector('[data-v5-spot]');
    var spots = spot ? JSON.parse(spot.getAttribute('data-spots')) : {};
    var bar = hero.querySelector('.v5-cycle');
    var dots = $all('.v5-dot', hero);
    var nameEl = hero.querySelector('[data-v5-dot-name]');
    var frame = hero.querySelector('.v5-hero-frame');
    var order = dots.map(function (d) { return d.getAttribute('data-color'); });
    var idx = 0, timer = null, held = false, visible = true;

    function show(color) {
      var dot = dots.filter(function (d) { return d.getAttribute('data-color') === color; })[0];
      if (!dot) return;
      dots.forEach(function (d) { d.classList.toggle('is-on', d === dot); });
      if (nameEl) nameEl.textContent = color;
      if (bar) bar.style.setProperty('--v5-cycle', dot.style.getPropertyValue('--c'));
      var p = spots[color];
      if (spot && p && frame) {
        /* follow the object-fit: cover crop (object-position 50% 45%) of the 1600x2000 plate */
        var fw = frame.clientWidth, fh = frame.clientHeight, sc = Math.max(fw / 1600, fh / 2000);
        var rw = 1600 * sc, rh = 2000 * sc, ox = (fw - rw) * 0.5, oy = (fh - rh) * 0.45;
        spot.style.transform = 'translate(' + (ox + rw * p[0] / 100).toFixed(1) + 'px,' + (oy + rh * p[1] / 100).toFixed(1) + 'px)';
        spot.classList.add('is-on');
      }
    }
    function tick() { if (held || !visible || document.hidden) return; idx = (idx + 1) % order.length; show(order[idx]); }
    function run() { if (motion && !timer) timer = setInterval(tick, 2800); }

    dots.forEach(function (d, i) {
      d.addEventListener('mouseenter', function () { held = true; idx = i; show(order[i]); });
      d.addEventListener('focus', function () { held = true; idx = i; show(order[i]); });
      d.addEventListener('mouseleave', function () { held = false; });
      d.addEventListener('blur', function () { held = false; });
    });
    window.addEventListener('resize', function () { show(order[idx]); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(hero);
    }
    setTimeout(function () { show(order[0]); run(); }, motion ? 1700 : 0);
  }

  /* color module: tabs with an auto-advancing progress bar while in view */
  var colors = document.querySelector('[data-v5-colors]');
  if (colors) {
    var chips = $all('.v5-chip', colors);
    var stage = colors.querySelector('.v5-colors-stage');
    var note = colors.querySelector('[data-v5-color-note]');
    var link = colors.querySelector('[data-v5-color-link]');
    var DWELL = 4600, cIdx = 0, cTimer = null, cHeld = false, cVisible = false;

    function select(i, user) {
      cIdx = i;
      var chip = chips[i], color = chip.getAttribute('data-color'), lc = color.toLowerCase();
      chips.forEach(function (c) {
        var on = c === chip;
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        var b = c.querySelector('.v5-chip-bar span');
        b.style.transition = 'none';
        b.style.transform = 'scaleX(0)';
      });
      stage.classList.add('is-live');
      $all('.v5-stage-img', stage).forEach(function (im) { im.classList.toggle('is-on', im.id === 'v5-stage-' + lc); });
      stage.setAttribute('aria-labelledby', chip.id);
      var breed = chip.getAttribute('data-breed');
      note.textContent = breed ? 'Shown on a ' + breed + '.' : '';
      link.href = '/products/mitsi-vest?color=' + color;
      link.querySelector('span').textContent = 'Shop ' + lc;
      if (user) { cHeld = true; clearTimeout(cTimer); return; }
      schedule();
    }
    function schedule() {
      clearTimeout(cTimer);
      if (!motion || cHeld || !cVisible) return;
      var b = chips[cIdx].querySelector('.v5-chip-bar span');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          b.style.transition = 'transform ' + DWELL + 'ms linear';
          b.style.transform = 'scaleX(1)';
        });
      });
      cTimer = setTimeout(function () { select((cIdx + 1) % chips.length); }, DWELL);
    }
    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { select(i, true); });
      c.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!k) return;
        e.preventDefault();
        var n = (i + k + chips.length) % chips.length;
        select(n, true);
        chips[n].focus();
      });
    });
    chips.forEach(function (c, i) { c.tabIndex = i === 0 ? 0 : -1; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        cVisible = es[0].isIntersecting;
        if (cVisible) schedule(); else clearTimeout(cTimer);
      }, { threshold: 0.4 }).observe(stage);
    }
  }

  /* parallax on the slab photos (transform only); data-v5-depth sets direction/strength */
  var plx = $all('[data-v5-parallax]');
  if (plx.length && motion) {
    var pTick = false;
    var update = function () {
      var vh = window.innerHeight;
      plx.forEach(function (box) {
        var r = box.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var t = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        var depth = parseFloat(box.getAttribute('data-v5-depth') || '5');
        box.firstElementChild.style.transform = 'translate3d(0,' + (t * depth).toFixed(2) + '%,0)';
      });
      pTick = false;
    };
    window.addEventListener('scroll', function () { if (!pTick) { pTick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
})();
